import {IFontPresets} from './architecture/sections/font-family.interface';
import {IGeneralColors} from './architecture/sections/general-colors.interface';
import {IFontSize} from './architecture/sections/font-size.interface';
import {ThemeIconsFactory} from './architecture/theme-icons-factory';
import {IThemeIcons} from './architecture/sections/theme-icons.interface';
import {createBaseUIComponents} from './base-ui-components-theme';
import {IBaseUIComponents, OrbitTheme} from './architecture/orbit-theme.interface';
import {mediaQueries} from "../services/media-query/media-queries";
import {css} from 'styled-components';
import {IThemeLayout} from './architecture/sections/theme-layout.interface';
import {IAssetsMap} from "./assets/assets-map.interface";



function createDefaultFontSizes(): IFontSize {
    return {
        xSmall: "10px",
        smallSecondary: "11px",
        small: "13px",
        mediumSecondary: "14px",
        medium: "15px",
        largeTertiary: "16px",
        largeSecondary: "17px",
        large: "18px",
        xLarge: "20px",
        xxLarge: "22px",
        xxxLarge: "30px"
    };
}

function createDefaultFontPresets(): IFontPresets {
    return {
        thin: css`
            /* font-family: "888-Orbit", verdana, sans-serif; */
            font-weight: 100;
        `,
        light: css`
            /* font-family: "888-Orbit", verdana, sans-serif; */
            font-weight: 300;
        `,
        regular: css`
            /* font-family: "888-Orbit", verdana, sans-serif; */
            font-weight: 400;
        `,
        medium: css`
            /* font-family: "888-Orbit", verdana, sans-serif; */
            font-weight: 500;
        `,
        body: css`
            /* font-family: "888-Orbit", verdana, sans-serif; */
            font-weight: 600;
        `,
        bold: css`
            /* font-family: "888-Orbit", verdana, sans-serif; */
            font-weight: 700;
        `,
        black: css`
            /* font-family: "888-Orbit", verdana, sans-serif; */
            font-weight: 800;
        `,
        ultra: css`
            /* font-family: "888-Orbit", verdana, sans-serif; */
            font-weight: 900;
        `,
        secondary: css`
            font-family: "Oleo-Script-Regular", verdana, sans-serif;
        `
    };
}

export interface MakeThemeOptions {
    assetsMap: IAssetsMap;
    fontSizes?: Partial<IFontSize>;
    fontPresets?: Partial<IFontPresets>;
    generalColors: IGeneralColors;
    themeSpecificIcons: Partial<IThemeIcons> | null;
    layout?: Partial<IThemeLayout>;
    baseUIComponents?(generalColors: IGeneralColors, defaults: IBaseUIComponents): IBaseUIComponents;
}


export function makeTheme(options: MakeThemeOptions): OrbitTheme {
    let defaultBaseUIComponents = createBaseUIComponents(options.generalColors);
    let baseUIComponents = options.baseUIComponents ? options.baseUIComponents(options.generalColors, defaultBaseUIComponents) : defaultBaseUIComponents;
    return {
        mediaQuery: mediaQueries,
        assets: options.assetsMap,
        font: {
            size: {...createDefaultFontSizes(), ...options.fontSizes},
            presets: {...createDefaultFontPresets(), ...options.fontPresets}
        },

        colors: options.generalColors,
        baseUIComponents,
        icons: new ThemeIconsFactory(options.themeSpecificIcons),
        layout: {
            border: {
                radius: '5px'
            },
            ...options.layout
        },
        components: {
            generalTitle: {
                colors: {
                    background: 'linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))'
                }

            },
            gamesListTitle: {
                colors: {
                    text: {
                        regular: options.generalColors.brandPrimary,
                        dailyJackpot: options.generalColors.brandSecondary,
                        redTigerJackpot: "#ff014f"
                    }
                }
            },
            modalDialog: {
                colors: {
                    background: options.generalColors.background
                },
                closeButtonSize: "18px"
            },
            newLiveCasino: {
                colors: {
                    filterButtonBackground: "#323232",
                    filterButtonLabel: "#CCC",
                    miniOrbit: {
                        filterButtonBackgroundNormal: `transparent linear-gradient(180deg, #4A4A4A 0%, #0C0C0C 100%) 0% 0% no-repeat padding-box`,
                        filterButtonBackgroundActive: `transparent linear-gradient(180deg, #0185DD 0%, #004270 100%) 0% 0% no-repeat padding-box`,
                        filterBorder: "#000000"
                    },
                    navbarBoxShadow: '#0c0c0c',
                    gridItem: {
                        closedMessageBackground: '#141414',
                        drawRedItemBackground: '#ff2f2f',
                        drawRedItemFirstChildBackground: '#DC1515',
                        drawGreenItemFirstChildBackground: '#3B8A08',
                        infobarBackground: '#191919',
                        wrapperBorder: '#5f5f5f'
                    }
                }
            },
            header: {
                colors: {
                    indicatorBadge: {
                        text: "#FFFFFF",
                        backgroundInGridLayout: "#FF014F",
                        backgroundInListLayout: "#171717"
                    }
                }
            },
            jackpotWidget: {
                font: {
                    clock: "'Digital7'"
                }
            },
            gamingHistory: {
                colors: {
                    background: options.generalColors.backgroundMiddleDark,
                    recordBackground: options.generalColors.backgroundDark,
                    textColor: options.generalColors.textLight
                }
            },
            miniOrbit: {
                colors: {
                    arenaMenuActiveIndicator: options.generalColors.brandPrimary
                }
            }
        }
    };
}


